var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye20Empty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "blindgeye-logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "blindgeye-logo__border",
    fill: "black",
    d: "M 0 10 C 11 23 23 23 34 10 C 23 -3 11 -3 0 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "blindgeye-logo__sclera",
    fill: "white",
    d: "M 2 10 C 11 21 23 21 32 10 C 23 -1 11 -1 2 10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "blindgeye-logo__iris-outter",
    fill: "black",
    d: "M 10 10 A 1 1 0 0 0 24 10 A 1 1 0 0 0 10 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "blindgeye-logo__iris-inner",
    fill: "rgb(206, 143, 209)",
    d: "M 11 10 A 1 1 0 0 0 23 10 A 1 1 0 0 0 11 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye20Empty);
export default __webpack_public_path__ + "static/media/eye20-empty.6b9b533dc02885764be3ce97cd421ab2.svg";
export { ForwardRef as ReactComponent };